import { FilterPopover, NO_AUTOFILL, type Align, type SortProps } from './FilterPopover';

interface Props extends SortProps {
  label: string;
  align?: Align;
  value: string | null;
  onChange: (next: string | null) => void;
  placeholder?: string;
}

/** Free-text column: a single "contains" input. */
export function TextFilterPopover({ label, align, value, onChange, placeholder = 'Contains…', ...sortProps }: Props) {
  return (
    <FilterPopover<string>
      label={label}
      align={align}
      {...sortProps}
      filterActive={!!value}
      value={value ?? ''}
      emptyValue=""
      onChange={(v) => onChange(v.trim() ? v.trim() : null)}
      isEmpty={(d) => !d.trim()}
      render={({ draft, setDraft }) => (
        <input
          type="text"
          className="column-filter-input"
          {...NO_AUTOFILL}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={placeholder}
          autoFocus
        />
      )}
    />
  );
}
